import { ApiError } from '../models/-index';

export function fnDeepCloneJ<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj)) as T;
}

export function fnRandomInRange(from, to) {
  var r = Math.random();
  return Math.floor(r * (to - from) + from);
}

export function fnFloatPlus(q1: any, q2: any): number {
  const _fq1 = parseFloat(q1 ?? '0');
  const _fq2 = parseFloat(q2 ?? '0');
  return Number((_fq1 + _fq2).toFixed(3));
  /*
  const _fq1 = parseFloat((q1 || 0).toFixed(3));
  const _fq2 = parseFloat((q2 || 0).toFixed(3));
  return _fq1 + _fq2; */
}
export function fnDecimalPlus(q1: any, q2: any): number {
  // alias
  return fnFloatPlus(q1, q2);
}
export function fnFloatMinus(q1: any, q2: any): number {
  const _fq1 = parseFloat(q1 ?? '0');
  const _fq2 = parseFloat(q2 ?? '0');
  return Number((_fq1 - _fq2).toFixed(3));
}
export function fnSelectorName(str: string): string {
  if (str) {
    return str
      .toLowerCase()
      .replace('app-', '')
      .replace(/[^0-9a-z]/gi, '');
  } else {
    return 'error_fnSelectorName';
  }
}

// non usata??

// https://gist.github.com/one89/395a3ffb2df4d0648ec7b0caf6cf5d37
export function fnGroupBy(data, keys) {
  // `data` is an array of objects, `keys` is the array of keys (or property accessor) to group by
  // reduce runs this anonymous function on each element of `data` (the `item` parameter,
  // returning the `storage` parameter at the end
  return data.reduce((storage, item) => {
    // returns an object containing keys and values of each item
    const groupValues = keys.reduce((values, key) => {
      values[key] = item[key];
      return values;
    }, {});

    // get the first instance of the key by which we're grouping
    const group = Object.values(groupValues).join(' ');

    // set `storage` for this instance of group to the outer scope (if not empty) or initialize it
    storage[group] = storage[group] || [];

    // add this item to its group within `storage`
    if (keys.every((key) => item[key] === groupValues[key])) {
      storage[group].push(item);
    }

    // return the updated storage to the reduce function, which will then loop through the next
    return storage;
  }, {}); // {} is the initial value of the storage
}
// usata in componenti macchie per generate codice
export function fnLeftPad(str: string, len: number = 0, ch: any = ' ') {
  str = String(str);
  ch = ch.toString();
  let i = -1;
  const length = len - str.length;

  while (++i < length && str.length + ch.length <= len) {
    str = ch + str;
  }
  return str;
}

export function fnRStringArrayLengthFixed(arr: string[], max: number = 100): string[] {
  // max=20;
  if (arr && arr.length > 0) {
    for (let x = 0; x < arr.length; x++) {
      let parole = arr[x];
      if (parole) {
        let istart = parole.length;
        if (istart < max) {
          const spaces = ' '.repeat(max - istart);

          parole = parole + spaces;
        } else {
          if (istart != max) {
            parole = parole.substring(0, max - 1) + '.';
          } else {
          }
        }
        arr[x] = parole;
      }
    }
  }

  return arr;
}
export function fnStringLengthFixed(parole: string, max: number = 100): string {
  // max=20;
  if (parole && parole.length > 0) {
    if (parole) {
      let istart = parole.length;
      if (istart < max) {
        const spaces = ' '.repeat(max - istart);

        parole = parole + spaces;
      } else {
        if (istart != max) {
          parole = parole.substring(0, max - 1) + '.';
        } else {
        }
      }
    }
  }

  return parole;
}

export function fnApiErrorFormat(x: ApiError | any) {
  let tmessage = `
  <b>${x.Message}</b><br />
  <small> `;
  if (x.Code) {
    tmessage += `code:  ${x.Code}<br />`;
  }
  if (x.Reference) {
    tmessage += `ref:  ${x.Reference}<br />`;
  }
  if (x.ServerResponse) {
    tmessage += `ref:  ${x.ServerResponse}<br />`;
  }
  tmessage += `</small>`;

  return tmessage;
}
// converte linguaggio 2 caratteri in 4 caratteri
export function fnConvertUiCulture(lng2letters: string) {
  let ret: string = 'it-IT';
  if (lng2letters != null) {
    switch (lng2letters) {
      case 'it':
        // ritorna il dafault
        break;
      case 'fr':
        ret = 'fr-FR';
        break;
      case 'en':
        ret = 'en-GB';
        break;

      default:
        // ritorna quello che è stato passato
        ret = lng2letters;
    }
  }
  return ret;
}
export function fnHideWord(w) {
  if (w.length < 3) return w;
  return w.substring(0, 2) + '*'.repeat(w.length + 1);
}
export function fnStringToBoolean(input: string): boolean | undefined {
  try {
    return JSON.parse(input.toLowerCase());
  } catch (e) {
    return undefined;
  }
}
